'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

exports['default'] = _iterableToArray;
//# sourceMappingURL=iterableToArray.js.map
